import { payrollSchema } from "./add-payroll-form";

export const EditPayrollSchema = payrollSchema.partial();